module.exports = __webpack_public_path__ + "4507fd5a6288bb92a25a5c4046a81d66.pdf";